import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { HashMap, TranslocoDirective } from '@jsverse/transloco';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'dss-libs-ui-chip',
  imports: [MatChip, TranslocoDirective, MatIcon],
  templateUrl: './chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  label = input<string | { key: string; params: HashMap }>('');
  color = input<string>('info');
  disabled = input<boolean>(false);
  clickable = input<boolean>(false);
  prefixSvgIcon = input<string>();
  suffixSvgIcon = input<string>();
  isKeyTranslated = input<boolean>(false);

  clickOutput = output<void>();

  readonly translatedLabel = computed(() => {
    const label = this.label();
    return typeof label === 'string' ? { key: label, params: undefined } : { key: label.key, params: label.params };
  });
}
